import { Transition } from '@headlessui/react'
import { useSelector } from 'react-redux'
import { messagesSelectors } from 'store/messages'
import { useTranslation } from 'react-i18next'
import { formatISODate } from 'utils/dates'
import { UIButton } from 'components/ui/Button'
import { showCloseTicketModal } from '../../managers/modal'

export const TicketInfoCard = () => {
  const { t } = useTranslation()
  const isInOperatorMode = useSelector(messagesSelectors.currentChatIsInOperatorMode)
  const ticket = useSelector(messagesSelectors.currentChatTicket)
  const disableFieldsTicketClosed = useSelector(messagesSelectors.disableFieldsTicketClosed)

  if (!ticket) {
    return null
  }

  return (
    <Transition
      show={isInOperatorMode && !!ticket}
      className={'tw-mt-1 tw-mb-1 tw-px-2'}
      enter="tw-transition-opacity tw-duration-300"
      enterFrom="tw-opacity-0"
      enterTo="tw-opacity-100"
      leave="tw-transition-opacity tw-duration-300"
      leaveFrom="tw-opacity-100"
      leaveTo="tw-opacity-0"
    >
      <div
        className={'tw-bg-primary-200 tw-p-2 tw-rounded-xl tw-transition-all tw-duration-500 tw-ease-in-out tw-text-sm'}
      >
        <div className={'tw-flex tw-text-white tw-flex-col tw-justify-start tw-items-start tw-space-y-1'}>
          <div className={'tw-font-extrabold'}>{t('youOpenedATicket')}</div>
          {/*<div className={'tw-text-sm'}>*/}
          {/*  <span className={'tw-font-bold'}>{t('title')}: </span>*/}
          {/*  <span>{ticket.title}</span>*/}
          {/*</div>*/}
          <div className={'tw-line-clamp-2 tw-text-sm'}>
            <span className={'tw-font-bold'}>{t('description')}: </span>
            <span>{ticket.description}</span>
          </div>
          <div className={'tw-text-xs tw-capitalize tw-italic tw-text-white tw-mt-1'}>
            {formatISODate(ticket.createdAt)}
          </div>
          <UIButton
            disabled={disableFieldsTicketClosed}
            className={'tw-w-full'}
            onClick={() => showCloseTicketModal(ticket._id)}
            style={{
              width: '10rem',
            }}
          >
            <span className={'tw-text-sm'}>{disableFieldsTicketClosed ? t('closedTicket') : t('closeTicket')}</span>
          </UIButton>
        </div>
      </div>
    </Transition>
  )
}
